import { Box } from '@factorialco/deprecated-design-system'
import { AtsGetJobPostingSettingsApplicationFormDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { SectionComponentLayout } from 'modules/ats/pages/JobPostingSettings/SectionComponentLayout'

import { ApplicationFormSkeleton } from './ApplicationFormSkeleton'
import { CustomQuestions } from './CustomQuestions'
import { PersonalInfo } from './PersonalInfo'

interface Props {
  jobId: string
}

export const ApplicationForm = ({ jobId }: Props) => {
  const { data, loading } = useQuery(AtsGetJobPostingSettingsApplicationFormDocument, {
    variables: {
      id: jobId,
    },
  })

  useEffect(() => {
    track(trackingEvents.ats.jobSettingsAccessApplicationForm)
  }, [])

  const job = data?.ats.jobPosting
  const customQuestions = data?.ats.questionsConnection?.nodes ?? []

  if (loading || !job) {
    return <ApplicationFormSkeleton />
  }
  return (
    <SectionComponentLayout>
      <Box gap="s40">
        <PersonalInfo job={job} />
        <CustomQuestions customQuestions={customQuestions} jobId={job.id} />
      </Box>
    </SectionComponentLayout>
  )
}
